import React from 'react';
import AtlasV2DoubleDropdownMetricColumnChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DoubleDropdownMetricColumnChart';
import { HIDE_GROUP_BY_LEVEL } from 'src/components/Layout/AtlasV2PageLayout';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';

/**
 *
 * Units Sold Summary double dropdown
 */
const AtlasV2UnitsSoldDoubleDropdownTopEntityChart = () => {
  const mainEntityType = useMainEntityType();

  return (
    <AtlasV2DoubleDropdownMetricColumnChart
      fields={[
        { fieldName: 'unitsSold', label: 'Units Sold' },
        { fieldName: 'onePUnitsSold', label: '1P Units Sold' },
        { fieldName: 'threePUnitsSold', label: '3P Units Sold' }
      ]}
      groupByFields={[
        {
          id: 'brandId',
          label: 'Brand',
          indexName: 'sales'
        },
        {
          id: 'categoryId',
          label: 'Category',
          indexName: 'sales'
        },
        {
          id: 'subCategoryId',
          label: 'Subcategory',
          indexName: 'sales'
        },

        {
          id: 'parentBrandId',
          label: 'Manufacturer',
          indexName: 'sales'
        }
      ].filter(
        (option) =>
          !option.id.toLowerCase().startsWith(mainEntityType) &&
          HIDE_GROUP_BY_LEVEL?.[mainEntityType]?.[option.id] !== true
      )}
    />
  );
};

export default AtlasV2UnitsSoldDoubleDropdownTopEntityChart;
